export default [
  {
    description: 'CrudExemplo',
    path: '/academico/crudexemplo',
    name: 'crudexemplo',
    component: () => import('@/views/academico/crudexemplo/Index.vue'),
    meta: {
      permissions: [

      ],
    },
    goesToMenu: true,
  },
  {
    description: 'Inclusão Crud Exemplo',
    path: '/academico/crudexemplo/incluir',
    parent: 'crudexemplo',
    name: 'crudexemploinsert',
    component: () => import('@/views/academico/crudexemplo/InclusaoEdicao.vue'),
    meta: {
      permissions: [

      ],
    },
  },
  {
    description: 'Exemplos Utilização Componentes',
    path: '/academico/crudexemplo/exemplo',
    parent: 'crudexemplo',
    name: 'exemplo',
    component: () => import('@/views/academico/crudexemplo/Exemplo.vue'),
    meta: {
      permissions: [

      ],
    },
  },
]

